import { formatDocumentToApiDocument } from './document-to-api-document';

import type {
  ApplicationData,
  Document,
  PartnerApplicationContext,
} from '../../model';

export function formatBusinessDocuments(
  data: ApplicationData,
  values: Partial<PartnerApplicationContext>['businessDocuments']
): ApplicationData {
  if (!values) return data;

  const docs: Document[] = [];

  docs.push(
    formatDocumentToApiDocument(values.BUSINESS_PERMIT, 'BUSINESS_PERMIT')
  );

  docs.push(
    formatDocumentToApiDocument(
      values.BIR_CERTIFICATE_OR_FORM2303,
      'BIR_CERTIFICATE_OR_FORM2303'
    )
  );

  docs.push(
    formatDocumentToApiDocument(values.DTI_CERTIFICATE, 'DTI_CERTIFICATE')
  );

  const other = values.OTHER ?? [];

  other.forEach((doc) => {
    docs.push(formatDocumentToApiDocument(doc, 'OTHER'));
  });

  return { ...data, businessDocuments: docs };
}
